/* eslint-disable i18next/no-literal-string -- styling, not user-visible */
import { defineSlotRecipe } from '@chakra-ui/react';

export const stat = defineSlotRecipe({
  className: 'chakra-stat',
  slots: ['root', 'label', 'helpText', 'valueUnit', 'valueText', 'indicator'],
  base: {
    root: {
      gap: 1,
    },
    label: {
      color: 'fg.solid',
      textStyle: 'sm',
      fontWeight: 'medium',
    },
    helpText: {
      opacity: 'unset',
      color: 'fg.solid',
    },
  },

  variants: {
    size: {
      sm: {
        label: { fontSize: 'md' },
        valueText: { fontSize: 'md', lineHeight: '1.2rem' },
        helpText: { fontSize: 'md' },
      },
      md: {
        label: { fontSize: 'md' },
        valueText: { fontSize: 'xl', lineHeight: '1.5rem' },
        helpText: { fontSize: 'md' },
      },
      xl: {
        label: { fontSize: 'md' },
        valueText: { fontSize: '4xl' },
        helpText: { fontSize: 'md' },
      },
    },
    variant: {
      default: {
        root: {
          display: 'flex',
          flexDirection: 'column',
        },
        helpText: {
          marginBottom: 0,
        },
      },
      list: {
        root: {
          display: 'flex',
          alignItems: 'baseline',
          flexDirection: 'row',
          gap: 0,
        },
        label: {
          fontSize: 'inherit',
          '&:after': {
            content: '":"',
          },
          fontWeight: 'normal',
          gap: 0,
        },
        valueText: {
          marginLeft: 1,
          fontSize: 'inherit',
          fontWeight: 'bold',
        },
        helpText: {
          color: 'gray.600',
          marginLeft: 2,
          alignItems: 'baseline',
        },
        indicator: {
          color: 'gray.600',
          alignItems: 'baseline',
        },
      },
    },
  },

  defaultVariants: {
    size: 'xl',
    variant: 'default',
  },
});
